import { Component, inject, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AssessmentFormService } from '../../services/assessment-form.service';
import { NonNullableFormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-load-form-dialog',
  templateUrl: './load-form-dialog.component.html',
  styleUrls: ['./load-form-dialog.component.scss']
})
export class LoadFormDialogComponent {

  isLoading = false;
  hasLoaded = false;
  hasError = false;
  validate = false;
  createdDate: string | null = null;



  formBuilder = inject(NonNullableFormBuilder);

  loadForm = this.formBuilder.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]],
  });

  constructor(
    public dialogRef: MatDialogRef<LoadFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private assessmentFormService: AssessmentFormService
  ) { }

  load(): void {
   
  
    this.validate = true;
    this.hasError = false;
    this.isLoading = true;

    // don't attempt to load if form is invalid, just return to the form and show validation errors
    if(this.loadForm.invalid){
      this.loadForm.markAllAsTouched();
      this.isLoading = false;
      return;
    }

    this.assessmentFormService.loadForm(this.loadForm.controls.email.value, this.loadForm.controls.password.value).subscribe({
      next: (form) => {
        console.log('Form loaded successfully:', form);
        this.createdDate = this.assessmentFormService.getCreatedDate()
        this.hasLoaded = true;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading form:', err);
        this.hasError = true;
        this.isLoading = false;
      }
    }); 

  }

  close(): void {
    console.log('Dialog closed');
    this.dialogRef.close();
  }

  continueClick(): void {

    console.log('Continue clicked');
    this.dialogRef.close({ action: 'continue', formLoaded: true  });
  }

  getDaysRemaining(): number {
    // Calculate days remaining using native Date
    if (!this.createdDate) {
      return 90;
    }

    const created = new Date(this.createdDate);
    
    // Check if date is valid
    if (isNaN(created.getTime())) {
      return 90;
    }

    // Add 90 days to the created date
    const expiryDate = new Date(created.getTime() + (90 * 24 * 60 * 60 * 1000));
    const now = new Date();
    
    // Calculate difference in days
    const timeDiff = expiryDate.getTime() - now.getTime();
    const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    
    return Math.max(0, daysDiff);
  }

}